import API_ENDPOINTS from "@/common/api/apiEndpoints";
import httpClient from "@/common/api/httpClient";
import httpMethods from "@/common/api/httpMethods";
import type { ReleaseFolder, ReleaseFolderTree } from "@/common/types/Cycle";

export const fetchReleaseFolders = (workspaceVersionId: number) =>
  httpClient<{ data: ReleaseFolderTree[] }>(
    httpMethods.GET,
    `${API_ENDPOINTS.CYCLES.releaseFolders}?workspaceVersionId=${workspaceVersionId}`,
  ).then((res) => res.data.data ?? []);

export const createReleaseFolder = (payload: {
  name: string;
  parent_id?: number | null;
  workspace_version_id: number;
}) =>
  httpClient<{ data: ReleaseFolder }>(
    httpMethods.POST,
    API_ENDPOINTS.CYCLES.releaseFolders,
    payload,
  ).then((res) => res.data.data);

export const updateReleaseFolder = (
  folderId: number,
  payload: { name?: string; parent_id?: number | null; position?: number },
) =>
  httpClient<{ data: ReleaseFolder }>(
    httpMethods.PUT,
    `${API_ENDPOINTS.CYCLES.releaseFolders}/${folderId}`,
    payload,
  ).then((res) => res.data.data);

export const deleteReleaseFolder = (folderId: number) =>
  httpClient<void>(
    httpMethods.DELETE,
    `${API_ENDPOINTS.CYCLES.releaseFolders}/${folderId}`,
  );
